<template lang="pug">
nav.flex.items-center.justify-between.flex-wrap.p-6.flex.items-center.flex-no-shrink.text-white.pb-4
   a.px-3.py-2.text-white.text-3xl(href='#/')
      img#logo(src="@/assets/logo2.svg" title="gootics")
   div(v-click-outside="hide")
      img.rounded-full.h-12.shadow(:src="image" @click="showMenu=!showMenu" :title="user.name")

      .menu.bg-white.rounded.text-grey-dark.text-left.shadow(:class='{hidden: showMenu}')
          .arrow-up
          ul.list-reset.leading-loose
            li
                a(href="#/Profile" @click="hide()") 👨 Profile
            li
                a(href="#/subscription" @click="hide()") 💰 Subscription
            li(v-if="!user.settings.darkmode")
                a(href="#" @click.prevent="setMode('darkmode'); hide()") 🌒 Dark Mode
            li(v-else)
                a(href="#" @click.prevent="setMode('lightmode'); hide()") ☀️ Light Mode
            li
                a(href="https://chrome.google.com/webstore/detail/gootics/lldkfknnilopekememhnjnhfebccdhol?hl=en" target="blank" @click="hide()") 🏄‍ Chrome Extension
            li
                a(href="#/contact" @click="hide()") 👋 Contact
            li
                a(@click="logout" href="#") 🚪 Log out
</template>

<script>
import axios from 'axios'
import ClickOutside from 'v-click-outside'

export default {
  name: 'Navigation',
  store: ['colorMode'],
  directives: {
    clickOutside: ClickOutside.directive
  },
  data () {
    return {
      showMenu: true,
      darkmode: false,
      user: {
        settings: {}
      },
      image: '@/assets/default-user.svg'
    }
  },
  created () {
    axios.get(`user`).then((user) => {
      this.user = user.data
      this.user.settings = this.user.settings || {}
      this.image = this.user.image || '@/assets/default-user.svg'
      localStorage.setItem('user', JSON.stringify(this.user))

      if (this.user.subscription) {
        axios.get(`subscription/substatus`).then((subscription) => {
          if (subscription.status === 200) { localStorage.setItem('subscription', JSON.stringify(subscription.data)) }
        })
      } else {
        localStorage.setItem('subscription', false)
      }
      if (this.user.settings.darkmode) {
        let body = document.body
        body.classList.remove('lightmode')
        body.classList.add('darkmode')
        this.colorMode = 'darkmode'
      }
    })
  },
  methods: {
    setMode (mode) {
      let body = document.body
      let oldClassName = 'lightmode'
      if (mode === 'lightmode') oldClassName = 'darkmode'
      this.colorMode = mode
      body.classList.remove(oldClassName)
      body.classList.add(mode)
      localStorage.setItem('darkmode', mode)

      this.user.settings.darkmode = !this.user.settings.darkmode

      axios.put(`user`, this.user)
    },
    hide () {
      if (!this.showMenu) this.showMenu = !this.showMenu
    },
    logout () {
      console.log('logout')
      localStorage.removeItem('token')
      localStorage.removeItem('subscription')
      localStorage.removeItem('user')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.menu {
   position: absolute;
   right: 1.5rem;
   top: 5.8rem;
   padding: 1rem;
   z-index: 9999;
   transform: translateZ(9999px);
}
.menu a {
   text-decoration: none;
}
.arrow-up {
   position: absolute;
   top: -.5rem;
   right: .5rem;
   width: 0px;
   height: 0px;
   -webkit-transform:rotate(360deg);
   border-style: solid;
   border-width: 0 15px 15px 15px;
   border-color: transparent transparent #ffffff transparent;
}

</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue